<script >
	export let x = 0;

</script>

<div class="heroContainer">

	<div class="heroTitle">
		<div class="heroTitleTxt">
		
			<!-- ArtiSaneFood -->
		</div>
	</div>

	<div class="heroSubTitle">
		<div class="heroSubTitleTxt">Food Safety</div>
	</div>

	<div class="heroSubTitle">
		<div class="heroSubTitleTxt">Decision - Support Tool</div>
	</div>

	<div class="primaLogoContainer">

		<div class="fsqa">
			
		</div>

		<div class="cimoLogo">
				
		</div>
			
		<div class="primaLogo">
				
		</div>

			

	</div>




</div>

<style>


	@media only screen and (min-width: 768px){

		.heroContainer{
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: center;
			background-color: transparent;
			/*animation-duration: 1.7s;
			animation-name: heroSlide;
			animation-iteration-count: 1;
			animation-timing-function:cubic-bezier(0.0, 0.0, 1.0, 1.0);*/

			
		}

		.heroContainer::before{
			content: "";
			background-color: white;
			position: absolute;
			top: 0px;
		  right: 0px;
		  bottom: 0px;
		  left: 0px;
		  opacity: 0.5;
		}

		@keyframes heroSlide {
			0% {

				opacity: 0;
			}
			100% {
				opacity: 0;
			}

		}

		.heroTitle{
			width: 100%;
			height: 40%;
			text-transform: none;
			margin-top: 2%;
			word-wrap: break-word;
			z-index: 9;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			/*background-color: darkcyan;*/
		}

		.heroTitleTxt{
			/*width: 400px;*/
			/*height: 400px;*/
			width: 26.041666666666668vw;
			height: 55.40166204986149vh;
			font-style: normal;
			font-weight: 900;
			font-size: 9vw;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-left: 0%;
			transform: translateY(4%);
			letter-spacing: 5%;
			z-index: 10;
			color: white;
			background-image: url('/img/logos/artisaneBig.png');
			background-repeat: no-repeat;
			background-size: contain;
			background-position: center center;
		}


		.heroSubTitle{
			width: 100%;
			height: fit-content;
			position: relative;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			/*background-color: darkgoldenrod;	*/
		}

		/*.heroSubTitle:nth-child(2) {
			margin-top: 2.5%;
		}*/

		.heroSubTitleTxt{
			width: fit-content;
			font-style: normal;
			font-weight: 900;
			opacity: 1.2;
			font-size: 3.5vw;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-left: 0%;
			text-transform: uppercase;
			color: black;
		}

		.primaLogoContainer{
			background-color: transparent;
			width:100%;
			height: auto;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-top: 2.5%;
			position: relative;
		}

		.primaLogo{
			width: 27.278645833333332vw;
			height: 18.005540166204987vh;
			background-image: url('/img/logos/prima_logo.png');
			background-repeat: no-repeat;
			background-size: contain;
			background-position: center center;
			transform: scale(0.5);


		}

		.cimoLogo{
			width: 27.278645833333332vw;
			height: 18.005540166204987vh;
			background-image: url('/img/logos/cimoBlack.png');
			background-repeat: no-repeat;
			background-size: contain;
			background-position: center center;
			transform: scale(0.8);
		}

		.fsqa{
			width: 27.278645833333332vw;
			height: 18.005540166204987vh;
			background-image: url('/img/logos/fsqa.png');
			background-repeat: no-repeat;
			background-size: contain;
			background-position: center center;
			transform: scale(0.7);
		}
	}
		


</style>